import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../apiUrl';


const TrackOrderPage = () => {
    const [orderId, setOrderId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleTrack = async (e) => {
        e.preventDefault();
        if (!orderId.trim()) return;

        setLoading(true);
        setError('');

        try {
            const response = await axios.get(`${API_URL}/order/track/${orderId.trim()}`);
            if (response.data && response.data.id) {
                // Redirect to the professional Detail Page
                navigate(`/order/${response.data.id}`);
            } else {
                setError('Pesanan tidak ditemukan.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Pesanan tidak ditemukan. Pastikan Order ID benar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="track-order-page" className="py-5" style={{ marginTop: '50px' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8">
                        <div className="db-order-summary-card p-5 text-center">
                            <div className="mb-4">
                                <i className="bi bi-search text-teal display-4"></i>
                            </div>
                            <h3 className="fw-bold mb-2">Lacak Pesanan</h3>
                            <p className="text-muted mb-5">Masukkan Order ID untuk melihat status pesanan Kakak secara real-time.</p>

                            <form onSubmit={handleTrack}>
                                <div className="db-input-group text-start">
                                    <label className="db-input-label">Order ID</label>
                                    <div className="position-relative">
                                        <span className="position-absolute top-50 translate-middle-y ms-4 text-muted">#</span>
                                        <input
                                            type="text"
                                            className="db-input-dark ps-5"
                                            placeholder="Contoh: 12345 atau FT2026..."
                                            value={orderId}
                                            onChange={(e) => setOrderId(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                </div>

                                {error && (
                                    <div className="alert alert-danger rounded-pill px-4 py-2 mt-3 small">
                                        <i className="bi bi-exclamation-circle me-2"></i> {error}
                                    </div>
                                )}

                                <button 
                                    type="submit" 
                                    className="db-btn-save w-100 mt-4 rounded-pill py-3" 
                                    disabled={loading || !orderId.trim()}
                                >
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                    ) : (
                                        <>Cek Status Pesanan <i className="bi bi-arrow-right ms-2"></i></>
                                    )}
                                </button>
                            </form>

                            <div className="mt-5 pt-4 border-top">
                                <p className="small text-muted mb-0">
                                    Butuh bantuan? <a href="https://wa.me/628131091521?text=Halo%20Admin%2C%20saya%20butuh%20bantuan%20mengenai%20pesanan%20saya..." className="text-teal text-decoration-none fw-bold" target="_blank" rel="noreferrer">Hubungi Customer Service</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrackOrderPage;
